var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"flex items-center h-10 px-4",class:_vm.item.class,attrs:{"href":_vm.item.url},domProps:{"innerHTML":_vm._s(_vm.item.name)}})}
var staticRenderFns = []

export { render, staticRenderFns }